module.exports = __webpack_public_path__ + "img/logo.ab19c96d.svg";